import { type DepreciationMethod, depreciationMethod } from '@libs/enums';
import type { OrEmpty } from '@ps-smart-cp/ppfw-client';
import type { DepreciationInfoFieldDisabledState } from '../types';

/**
 * 償却方法に応じて償却情報の各項目の非活性状態を判定する
 *
 * @param method 償却方法
 * @returns 項目ごとの非活性状態
 */
function judgeDepreciationInfoFieldDisabledState(
  method: OrEmpty<DepreciationMethod>,
): DepreciationInfoFieldDisabledState {
  const isMonthsDisabled =
    method === depreciationMethod.enum.twoHundredDclBalMethod ||
    method === depreciationMethod.enum.straightLineMethod;

  return {
    isLifeDisabled:
      method === depreciationMethod.enum.monthlyInstallmentDepreciation ||
      method === depreciationMethod.enum.laPeriodStraightLineMethod,
    isDepreciationMonthsDisabled: isMonthsDisabled,
    isRemainingMonthsDisabled: isMonthsDisabled,
    isRevisedAcquisitionValueDisabled: method !== depreciationMethod.enum.twoHundredDclBalMethod,
  };
}

export { judgeDepreciationInfoFieldDisabledState };
